<template>
  <div>
    <b-modal
      id="modal-camera"
      size="lg"
      ok-title="Save"
      cancel-title="Cancel"
      class="h-100 test"
      hide-header
      centered
      no-close-on-backdrop
    >
      <div class="fullscreen-camera">
        <div class="camera-stack bg-dark">
          <vue-web-cam
            class="video-camera my-auto"
            ref="webcam"
            :device-id="deviceId"
            height="100%"
            width="100%"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
          >
          </vue-web-cam>
          <div class="position-absolute w-100" style="right: 0">
            <h5
              @click="closeModal()"
              class="text-white mx-3 mt-2 position-absolute"
              style="font-size: 1.5rem; right: 0"
            >
              x
            </h5>
          </div>
          <div class="position-absolute w-100" style="bottom: 0">
            <div
              class="d-flex w-100 justify-content-around align-items-center mb-3"
            >
              <div></div>
              <img
                src="@/assets/mobile/fillin/btn-camera.png"
                alt="button_camera"
                style="max-width: 4rem"
                @click="onCapture"
              />
              <div>
                <a
                  v-if="devices.length > 1"
                  class="secondary-button"
                  role="button"
                  @click="switchCamera()"
                >
                  <i
                    class="fa fa-refresh text-white"
                    style="font-size: 2rem"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
            </div>
          </div>

          <!-- <div class="d-flex">
            <h5
              @click="closeModal()"
              class="ms-auto text-white mx-3 mt-2"
              style="font-size: 1.5rem"
            >
              x
            </h5>
          </div>
          <vue-web-cam
            class="video-camera my-auto p-3"
            ref="webcam"
            :device-id="deviceId"
            height="100%"
            width="100%"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
          >
          </vue-web-cam>
          <div class="cursor-pointer">
            <div class="d-flex justify-content-around align-items-center mb-3">
              <div></div>
              <img
                src="@/assets/mobile/fillin/btn-camera.png"
                alt="button_camera"
                style="max-width: 4rem"
                @click="onCapture"
              />
              <div>
                <a
                  v-if="devices.length > 1"
                  class="secondary-button"
                  role="button"
                  @click="switchCamera()"
                >
                  <i
                    class="fa fa-refresh text-white"
                    style="font-size: 2rem"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
            </div>
          </div> -->
          <!-- <div class="text-center cursor-pointer" @click="onCapture">
            <img
              src="@/assets/mobile/fillin/btn-camera.png"
              alt="button_camera"
              class="mb-3"
              style="max-width: 4rem"
            />
          </div> -->
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { WebCam } from "vue-web-cam";
export default {
  props: {
    isStartCamera: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    "vue-web-cam": WebCam,
  },
  data() {
    return {
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      indexChooseCamera: 0,
    };
  },
  computed: {
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      if(this.devices && this.devices.length > 0) {
        if (this.devices && this.devices.length <= 1) {
        const [first, ...tail] = this.devices;
        if (first) {
          this.camera = first.deviceId;
          this.deviceId = first.deviceId;
          console.log("tail", tail);
        }
      } else {
        let camChoose = this.devices && this.devices.length > 0 ? this.devices : [];
        this.camera = camChoose[1].deviceId;
        this.deviceId = camChoose[1].deviceId;
      }
      }
      
    },
    isStartCamera: "startCamera",
  },
  methods: {
    startCamera() {
      console.log('isStartCamera',this.isStartCamera);
      if (this.isStartCamera == true) {
        this.devices = [];
        this.deviceId = null;
        this.indexChooseCamera = this.devices.length <= 1 ? 0 : 1;
      }
    },
    onCapture() {
      this.img = this.$refs.webcam.capture();
      this.$emit("snapImage", this.img);
      this.$emit("clearStatusCamera");
    },
    onStarted(stream) {
      console.log("On Started Event", stream);
    },
    onStopped(stream) {
      console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      console.log("On Error Event", error);
    },
    // กล้องทั้งหมด
    onCameras(cameras) {
      console.log('onCameras1')
        // this.deviceId = null;
      //   this.devices = [];
      this.devices = cameras;
      
      // console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      console.log('onCameraChange');
      this.deviceId = deviceId;
      this.camera = deviceId;
      console.log("On Camera Change Event", deviceId);
    },
    async closeModal() {
      await this.onStop();
      this.$bvModal.hide("modal-camera");
      this.$emit("clearStatusCamera");
    },
    switchCamera() {
      if (this.devices.length <= 2) {
        let indexDevice = this.devices.findIndex(
          (dv) => dv.deviceId == this.deviceId
        );
        this.deviceId =
          indexDevice == 0
            ? this.devices[1].deviceId
            : this.devices[0].deviceId;
        this.camera =
          indexDevice == 0
            ? this.devices[1].deviceId
            : this.devices[0].deviceId;
      } else {
        //มีกล้องมากกว่า 2
        if (this.indexChooseCamera == this.devices.length - 1) {
          //กล้องตัวสุดท้าย
          this.indexChooseCamera = 0;
        } else {
          this.indexChooseCamera++;
        }
        this.deviceId = this.devices[this.indexChooseCamera].deviceId;
        this.camera = this.devices[this.indexChooseCamera].deviceId;
      }
    },
  },
};
</script>
<style lang="scss">
#modal-camera .modal.show .modal-dialog {
  height: 100% !important;
}
#modal-camera .modal-content {
  height: 100% !important;
}
#modal-camera {
  --bs-modal-margin: 0 !important;
  --bs-modal-border-color: white;
  --bs-modal-border-width: 0;
  --bs-modal-border-radius: 0;
}

.modal-footer {
  border-top: none !important;
}

.fullscreen-camera {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
}

.camera-stack {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}

.video-camera {
  object-fit: cover;
}
</style>
